import * as React from 'react';

import SvgContainer from './SvgContainer';

function SvgInkDrop( { width, height, color = "#ffffff", ...remProps } ){
  return (
    <SvgContainer { ...remProps }
      width={ width }
      height={ height }
      fill="none" xmlns="http://www.w3.org/2000/svg"
    >
      <path d='M4.125 11C1.84766 11 0 9.15234 0 6.875C0 4.91563 2.79727 1.23965 3.5793 0.251367C3.7082 0.0902344 3.89941 0 4.10566 0H4.14434C4.35059 0 4.5418 0.0902344 4.6707 0.251367C5.45273 1.23965 8.25 4.91563 8.25 6.875C8.25 9.15234 6.40234 11 4.125 11ZM2.0625 7.21875C2.0625 7.02969 1.90781 6.875 1.71875 6.875C1.52969 6.875 1.375 7.02969 1.375 7.21875C1.375 8.54863 2.45137 9.625 3.78125 9.625C3.97031 9.625 4.125 9.47031 4.125 9.28125C4.125 9.09219 3.97031 8.9375 3.78125 8.9375C2.83164 8.9375 2.0625 8.16836 2.0625 7.21875Z'
        fill={color}
      />
    </SvgContainer>
  );
}

export default SvgInkDrop;
